<template>
<v-progress-linear v-if="value > 0" color="light-blue" height="5" :value="value" fixed :bottom="this.$vuetify.breakpoint.smAndDown ? false : true"></v-progress-linear>
</template>

<script>
export default {
  name: 'ProgressBar',
  data() {
    return {
      value: 0
    }
  },
  created() {
    window.addEventListener('scroll', this.progress);
  },
  methods: {
    progress() {
      var progressMax = document.body.clientHeight - window.innerHeight;
      var scrollPosition = window.scrollY;
      this.value = scrollPosition * 100 / progressMax;
    }
  }
}
</script>
